import { Component, type ReactNode } from "react";
import { type RouteComponentProps } from "react-router";

import { track } from "utilities/analytics/analytics";
import { getJobPickerState } from "utilities/jobPicker/jobPicker";
import { routesWebforms } from "utilities/routesWebforms";

import { HotkeyDisplaySetup } from "commonComponents/helpers/HotkeyDisplaySetup/HotkeyDisplaySetup";
import {
    type IJobPickerHandler,
    JobPickerHandler,
} from "commonComponents/utilities/JobPicker/JobPicker.api.handler";

import { type SystemFilterType } from "entity/filters/Filter/Filter.api.types";

export interface IEntityListWrapperState {
    jobIds: number[];
    jobName: string;
    isTemplateMode: boolean;
    systemFilter?: SystemFilterType;
    isRouteJobIdDifferent?: boolean;
    allJobsSelected: boolean;
    allBuildersSelected: boolean;
}

interface IEntityListWrapperRouteProps {
    jobId: string;
}

interface IEntityListWrapperProps {
    render: (state: IEntityListWrapperState) => ReactNode;
    reactRouterProps?: RouteComponentProps<IEntityListWrapperRouteProps>;
    jobPickerHandler?: IJobPickerHandler;
}

/* This should only be used on Webforms list pages */

export default class EntityListWrapper extends Component<
    IEntityListWrapperProps,
    IEntityListWrapperState
> {
    static defaultProps = {
        jobPickerHandler: new JobPickerHandler(),
    };

    state: Readonly<IEntityListWrapperState> = {
        jobIds: [],
        jobName: "",
        isTemplateMode: getJobPickerState().isTemplateMode,
        allBuildersSelected: false,
        systemFilter: parseSystemFilterQS(),
        isRouteJobIdDifferent: undefined,
        allJobsSelected: false,
    };

    render() {
        return (
            <TrackedWrapper jobIds={this.state.jobIds}>
                {this.props.render(this.state)}
                <HotkeyDisplaySetup />
            </TrackedWrapper>
        );
    }
}

function parseSystemFilterQS() {
    let systemFilter: SystemFilterType | undefined;
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has("filter")) {
        systemFilter = Number(queryParams.get("filter"));
        queryParams.delete("filter");
        routesWebforms.replaceWebformsHistoryState("?" + queryParams.toString());
    }
    return systemFilter;
}

interface ITrackedWrapperProps {
    jobIds?: number[];
    children: React.ReactNode;
}

export const TrackedWrapper: React.FunctionComponent<ITrackedWrapperProps> = track((props) => ({
    jobId: (props.jobIds?.length ?? 0) === 1 ? props.jobIds[0] : 0,
}))((props) => <>{props.children}</>);
